module.exports = __webpack_public_path__ + "media/images/emblems/Olten-blason-2769ae48cae8e544e0fc30dfa5916199.png";